<template>
  <div style="position: relative; overflow-y: hidden; overflow-x: hidden; z-index: 0">
    <div :class="[{'blurBg': true}, {'active': blurActive}]"></div>
    <div>
      <img src="/images/decoration/portfolio/bigWavee.svg" class="bigWavee">
      <img src="/images/decoration/hero/triangles.svg" class="triangles">
      <img src="/images/decoration/portfolio/wave2.svg" class="wave2">
      <img src="/images/decoration/portfolio/bigBlueStar.svg" class="bigBlueStar">
      <img src="/images/decoration/portfolio/smallBlueStar.svg" class="smallBlueStar">
      <img src="/images/decoration/portfolio/bigWhiteStar.svg" class="bigWhiteStar">
      <img src="/images/decoration/portfolio/smallWhiteStar.svg" class="smallWhiteStar">

      <img src="/images/decoration/portfolio/veryBigWhiteStar.svg" class="veryBigWhiteStar">
      <img src="/images/decoration/portfolio/smalLDarkStar.svg" class="smallDarkStar">

      <img src="/images/decoration/aboutUs/triangles.svg" class="triangles2">
      <img src="/images/decoration/aboutUs/circle.svg" class="circle">

      <img src="/images/decoration/portfolio/smalLDarkStar.svg" class="smallDarkStar2">
    </div>
    <Navbar @blur="blur"></Navbar>
    <CarouselPortfolio data-aos="fade-up" :websites="websites" style="margin-top: 8rem; margin-bottom: 10rem"></CarouselPortfolio>
    <ContactSection style="margin-bottom: 8rem"></ContactSection>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import ContactSection from "@/components/ContactSection";
import CarouselPortfolio from "@/components/CarouselPortfolio";
import Footer from "@/components/Footer";
export default {
  name: "Portfolio",
  data() {
    return {
      websites: [],
      blurActive: false
    }
  },
  components: {Footer, CarouselPortfolio, ContactSection, Navbar},
  methods: {
    blur(value) {
      this.blurActive = value;
    }
  }, created() {

    const portfolio = process.env.VUE_APP_PORTFOLIO;

    this.websites = JSON.parse(portfolio);
  }
}
</script>

<style scoped lang="scss">
@import "~bulma/sass/utilities/mixins";
.bigWavee {
  position: absolute;
  z-index: -5;
  top: -500px;
  right: -500px;
  transform: scale(0.8);

  @include until(1200px) {
    top: -120px;
    right: -500px;
  }

  @include touch {
    transform: scale(2.5);
    top: 200px;
    right: -5--0px;
  }
}

.triangles {
  position: absolute;
  z-index: -5;
  top: -50px;
  left: 75px;
  transform: scale(0.8)
}

.wave2 {
  position: absolute;
  z-index: -5;
  bottom: -300px;
  left: -50px;
  transform: scale(1)
}

.bigBlueStar {
  position: absolute;
  z-index: -4;
  top: 300px;
  right: 300px;
  transform: scale(1);

  @include touch {
    display: none;
  }
}

.smallBlueStar {
  position: absolute;
  z-index: -4;
  top: 250px;
  right: 200px;
  transform: scale(1);

  @include touch {
    display: none;
  }
}

.bigWhiteStar {
  position: absolute;
  z-index: -4;
  top: 325px;
  left: 250px;
  transform: scale(1);

  @include touch {
    display: none;
  }
}

.smallWhiteStar {
  position: absolute;
  z-index: -4;
  top: 250px;
  left: 200px;
  transform: scale(1);

  @include touch {
    display: none;
  }
}

.veryBigWhiteStar {
  position: absolute;
  z-index: -4;
  bottom: 225px;
  left: 175px;
  transform: scale(0.8);

  @include touch {
    display: none;
  }
}

.smallDarkStar {
  position: absolute;
  z-index: -4;
  bottom: 200px;
  left: 150px;
  transform: scale(0.8);

  @include touch {
    display: none;
  }
}

.triangles2 {
  position: absolute;
  z-index: -4;
  bottom: 400px;
  right: -475px;
  transform: scale(0.5)
}

.circle {
  position: absolute;
  z-index: -4;
  bottom: 400px;
  left: -550px;
  transform: scale(0.6);
  filter: blur(5px);
}

.smallDarkStar2 {
  position: absolute;
  z-index: -4;
  bottom: 400px;
  right: 150px;
  transform: scale(0.6);

  @include touch {
    display: none;
  }
}
</style>
